var map = {
	"./add-client-1.svg": 9794,
	"./addfaciltator_grey.svg": 23,
	"./arrowIcon.svg": 3553,
	"./change-team.svg": 4803,
	"./check-mark.svg": 5997,
	"./close-icon.svg": 6645,
	"./complete-icon.svg": 4552,
	"./courseMaterial_icon.svg": 2789,
	"./deleteIcon.svg": 1717,
	"./detail_triangle.svg": 9683,
	"./download_icon.svg": 1869,
	"./fullscreen_icon.svg": 384,
	"./guide_available_icon.svg": 7883,
	"./guide_icon.svg": 6471,
	"./hub_logo_white.svg": 1708,
	"./hub_spacer.svg": 8059,
	"./icon-add-facilitator.svg": 1731,
	"./icon-cert-1.svg": 7553,
	"./icon-client-list.svg": 965,
	"./icon-close.svg": 2023,
	"./icon-dashboard.svg": 5563,
	"./icon-guide-disabled.svg": 528,
	"./icon-guide.svg": 8047,
	"./icon-logout-btn.svg": 1052,
	"./icon-logout.svg": 6371,
	"./icon-profile.svg": 4488,
	"./icon-time-estimate.svg": 8185,
	"./journal_icon.svg": 2640,
	"./linkedin_icon.svg": 7291,
	"./missing-team.svg": 4821,
	"./more_info_icon.svg": 3937,
	"./pdf_icon.svg": 7161,
	"./powerpoint_icon.svg": 1776,
	"./recordedVideo_icon.svg": 1228,
	"./register_icon.svg": 8712,
	"./registration_breakline-2.svg": 8775,
	"./registration_breakline.svg": 5310,
	"./selection_arrow.svg": 4049,
	"./theme-guide-btn-1.svg": 7624,
	"./theme-guide-btn-2.svg": 8987,
	"./theme-module-btn-1.svg": 590,
	"./theme-module-btn-2.svg": 4957,
	"./theme-video-btn-1.svg": 1653,
	"./theme-video-btn-2.svg": 2342,
	"./triangle.svg": 239,
	"./video_icon.svg": 6036,
	"./wave.svg": 8916,
	"./wordDoc_icon.svg": 7841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9390;